"use strict"; // Copyright (C) 2021 Toitware ApS. All rights reserved.
// Use of this source code is governed by an MIT-style license that can be
// found in the LICENSE file.

var _regeneratorRuntime = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/wizard/wizard/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Completer = exports.Reader = void 0;

var errors_1 = require("./errors");

var util_1 = require("./util");

var Reader = /*#__PURE__*/function () {
  function Reader(readableOwner) {
    _classCallCheck(this, Reader);

    this.running = false;
    this.closing = false;
    this.reader = undefined;
    this.completer = undefined;
    this.runPromise = undefined;
    this.listenRef = 0;
    this.buffer = new util_1.Uint8Buffer();
    this.readableOwner = readableOwner;
  }

  _createClass(Reader, [{
    key: "start",
    value: function start() {
      if (this.runPromise !== undefined) {
        throw errors_1.AlreadyRunningError;
      }

      this.buffer.reset();
      this.closing = false;
      this.runPromise = this.run();
    }
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.runPromise === undefined)) {
                  _context.next = 2;
                  break;
                }

                throw errors_1.NotRunningError;

              case 2:
                this.closing = true;

                if (!(this.reader !== undefined)) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 4;
                _context.next = 7;
                return this.reader.cancel();

              case 7:
                _context.next = 11;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](4);

              case 11:
                _context.prev = 11;
                _context.next = 14;
                return this.runPromise;

              case 14:
                return _context.abrupt("return", undefined);

              case 17:
                _context.prev = 17;
                _context.t1 = _context["catch"](11);
                return _context.abrupt("return", _context.t1);

              case 20:
                _context.prev = 20;
                this.buffer.reset();
                this.runPromise = undefined;
                return _context.finish(20);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 9], [11, 17, 20, 24]]);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var reader, _yield$reader$read, value, done;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                this.running = true;

              case 2:
                if (this.closing) {
                  _context2.next = 40;
                  break;
                }

                if (this.reader === undefined) {
                  this.reader = this.readableOwner.readable.getReader();
                }

                reader = this.reader;
                _context2.prev = 5;
                _context2.next = 8;
                return reader.read();

              case 8:
                _yield$reader$read = _context2.sent;
                value = _yield$reader$read.value;
                done = _yield$reader$read.done;

                if (!done) {
                  _context2.next = 17;
                  break;
                }

                reader.releaseLock();
                this.reader = undefined;
                _context2.next = 16;
                return (0, util_1.sleep)(1);

              case 16:
                return _context2.abrupt("continue", 2);

              case 17:
                if (value) {
                  _context2.next = 19;
                  break;
                }

                return _context2.abrupt("continue", 2);

              case 19:
                if (this.listenRef > 0) {
                  this.buffer.copy(value);
                }

                if (this.completer !== undefined) {
                  this.completer.complete();
                }

                _context2.next = 38;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2["catch"](5);

                if ((0, util_1.isTransientError)(_context2.t0)) {
                  _context2.next = 27;
                  break;
                }

                throw _context2.t0;

              case 27:
                _context2.prev = 27;
                _context2.next = 30;
                return reader.cancel();

              case 30:
                _context2.next = 34;
                break;

              case 32:
                _context2.prev = 32;
                _context2.t1 = _context2["catch"](27);

              case 34:
                reader.releaseLock();
                this.reader = undefined;
                _context2.next = 38;
                return (0, util_1.sleep)(1);

              case 38:
                _context2.next = 2;
                break;

              case 40:
                _context2.prev = 40;

                if (!(this.reader !== undefined)) {
                  _context2.next = 51;
                  break;
                }

                _context2.prev = 42;
                _context2.next = 45;
                return this.reader.cancel();

              case 45:
                _context2.next = 49;
                break;

              case 47:
                _context2.prev = 47;
                _context2.t2 = _context2["catch"](42);

              case 49:
                this.reader.releaseLock();
                this.reader = undefined;

              case 51:
                this.running = false;
                return _context2.finish(40);

              case 53:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0,, 40, 53], [5, 23], [27, 32], [42, 47]]);
      }));

      function run() {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }, {
    key: "listen",
    value: function listen() {
      var _this = this;

      if (!this.running) {
        throw errors_1.NotRunningError;
      }

      this.listenRef++;
      return function () {
        _this.listenRef--;

        if (_this.listenRef < 0) {
          throw "Listen ref count is negative";
        }

        if (_this.listenRef == 0) {
          _this.buffer.reset();
        }
      };
    }
  }, {
    key: "waitData",
    value: function () {
      var _waitData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(minLength) {
        var timeoutMs,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                timeoutMs = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : undefined;

                if (this.running) {
                  _context3.next = 3;
                  break;
                }

                throw errors_1.NotRunningError;

              case 3:
                if (!(this.completer !== undefined)) {
                  _context3.next = 5;
                  break;
                }

                throw errors_1.ReadAlreadyInProgressError;

              case 5:
                if (!(this.buffer.length < minLength)) {
                  _context3.next = 15;
                  break;
                }

                this.completer = new Completer(timeoutMs);
                _context3.prev = 7;
                _context3.next = 10;
                return this.completer.promise;

              case 10:
                _context3.prev = 10;
                this.completer = undefined;
                return _context3.finish(10);

              case 13:
                _context3.next = 5;
                break;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7,, 10, 13]]);
      }));

      function waitData(_x) {
        return _waitData.apply(this, arguments);
      }

      return waitData;
    }()
  }, {
    key: "waitSilent",
    value: function () {
      var _waitSilent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(retry, timeoutMs) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!retry--) {
                  _context4.next = 16;
                  break;
                }

                this.buffer.reset();
                _context4.prev = 2;
                _context4.next = 5;
                return this.waitData(1, timeoutMs);

              case 5:
                _context4.next = 12;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](2);

                if (!(_context4.t0 === errors_1.TimeoutError)) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", true);

              case 11:
                throw _context4.t0;

              case 12:
                _context4.next = 14;
                return (0, util_1.sleep)(50);

              case 14:
                _context4.next = 0;
                break;

              case 16:
                return _context4.abrupt("return", false);

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 7]]);
      }));

      function waitSilent(_x2, _x3) {
        return _waitSilent.apply(this, arguments);
      }

      return waitSilent;
    }()
  }, {
    key: "read",
    value: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(minLength, timeoutMs) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.listenRef <= 0)) {
                  _context5.next = 2;
                  break;
                }

                throw errors_1.NotListeningError;

              case 2:
                _context5.next = 4;
                return this.waitData(minLength, timeoutMs);

              case 4:
                return _context5.abrupt("return", this.buffer.view(true));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function read(_x4, _x5) {
        return _read.apply(this, arguments);
      }

      return read;
    }()
  }, {
    key: "packet",
    value: function () {
      var _packet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(minLength, timeoutMs) {
        var maxRetries, res;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(this.listenRef <= 0)) {
                  _context6.next = 2;
                  break;
                }

                throw errors_1.NotListeningError;

              case 2:
                maxRetries = 1000;

              case 3:
                if (!maxRetries--) {
                  _context6.next = 12;
                  break;
                }

                _context6.next = 6;
                return this.waitData(minLength, timeoutMs);

              case 6:
                res = this.buffer.packet();

                if (!(res !== undefined)) {
                  _context6.next = 9;
                  break;
                }

                return _context6.abrupt("return", res);

              case 9:
                // no packet was available in minLength, so we wait for another byte.
                minLength++;
                _context6.next = 3;
                break;

              case 12:
                throw errors_1.TimeoutError;

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function packet(_x6, _x7) {
        return _packet.apply(this, arguments);
      }

      return packet;
    }()
  }]);

  return Reader;
}();

exports.Reader = Reader;

var Completer = /*#__PURE__*/function () {
  function Completer() {
    var _this2 = this;

    var timeoutMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    _classCallCheck(this, Completer);

    this.promise = new Promise(function (resolve, reject) {
      _this2._complete = resolve;
      _this2._reject = reject;

      if (timeoutMs !== undefined) {
        if (timeoutMs > 0) {
          setTimeout(function () {
            return reject(errors_1.TimeoutError);
          }, timeoutMs);
        } else {
          reject(errors_1.TimeoutError);
        }
      }
    });
  }

  _createClass(Completer, [{
    key: "complete",
    value: function complete(value) {
      if (this._complete !== undefined) {
        this._complete(value);
      }
    }
  }, {
    key: "reject",
    value: function reject(reason) {
      if (this._reject !== undefined) {
        this._reject(reason);
      }
    }
  }]);

  return Completer;
}();

exports.Completer = Completer;